import { render, staticRenderFns } from "./CustomerLevel.vue?vue&type=template&id=480e73ce&"
import script from "./CustomerLevel.vue?vue&type=script&lang=js&"
export * from "./CustomerLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports